import React from 'react';
import AuthProvider from './state/AuthProvider';
import ChatWidget from './ChatWidget';
import TenantProvider from './state/TenantProvider';
import ChatProvider from './state/ChatProvider';
import { initialiseHttpService } from './utils/httpService';

const App = () => {
    initialiseHttpService();
    
    return (
        <TenantProvider>
            <AuthProvider>
                <ChatProvider>
                    <ChatWidget />
                </ChatProvider>
            </AuthProvider>
        </TenantProvider>
    );
}

export default App;